import { Auth, API, Cache, Logger } from 'aws-amplify'

const loggerRefresh = new Logger('RefreshHandler', 'INFO');
const loggerSingIn = new Logger('API SingIn', 'INFO');

/**
 * refresca las credenciales de un user usando el openid token que se genera al inciar sesion
 * @returns {
 * 	token // string, openid token
 * 	expires_at // int, ts the expiracion
 * 	identity_id // string, identity id del usuario
 * }
 */
export async function refrescarTokens(){

	function getFederatedInfo(){
		let tmp = localStorage['aws-amplify-federatedInfo']
		loggerRefresh.info('aws-amplify-federatedInfo:', tmp)
		loggerRefresh.info('obteniendo informacion de sesion del usuario')
		const federatedInfo = Cache.getItem('federatedInfo');
		loggerRefresh.info('federatedInfo', federatedInfo)
		if( federatedInfo )	return federatedInfo;
		loggerRefresh.info('no se ha encontrado federatedInfo en cache, intentando local storage')
		let storage = localStorage['aws-amplify-federatedInfo']
		if(!tmp){
			loggerRefresh.info('no se ha encontrado federatedInfo en storage')
			loggerRefresh.info('no hay usuario logeado')
			return false;
		}
		let cacheContent = JSON.parse(tmp);
		loggerRefresh.info('cacheContent', cacheContent)
		const expires_at = cacheContent.expires_at
		loggerRefresh.info('cache expira el', new Date(expires_at))

		const expirado = new Date() > new Date(expires_at)
		loggerRefresh.info('credenciales expires_at', expires_at)
		loggerRefresh.info('credenciales expiradas?', expirado)
		return { ...cacheContent, expirado }
	}

	const federatedInfo = getFederatedInfo()

	if( !federatedInfo ){
		// iniciar sesion
		loggerRefresh.info('no hay sesion iniciada, debe iniciar sesion')
		return {};
	}else if( federatedInfo.expirado ){
		// refrescar
		loggerRefresh.info('la sesion ha expirado, hay que refrescar el token.')
		try{
			let resp = await apiRefreshToken(federatedInfo)
			return resp;
		}catch(e){
			loggerRefresh.error('ERROR AL REFRESCAR EL TOKEN', e)
			throw e;
		}
	}else{
		// retornar sesion
		loggerRefresh.info('la sesion es valida, retornando...')
		const { token, expires_at, identity_id } = federatedInfo;
		const data = {
			token, // the token from the provider
			expires_at, // the timestamp for the expiration
			identity_id // optional, the identityId for the credentials
		};
	
		return data;
	}
}

export async function apiSignin(params, authMethod, headers={}){

	loggerSingIn
	const payload = {
		headers,
		body: {
			...params,
			opts:{authMethod}
		}
	}

	try{
		
		let resp = await API.post('apiAuthSII', '/sign-in', payload)
		return resp;
	}catch(e){
		console.warn('---', e)
		throw e.response.data;
	}
}

export async function apiSignInExternos(idSesion){

	// const headers = new Headers()
	// headers.append('authorization', document.cookie)
	// headers.append("Set-Cookie", document.cookie);
	
	const headers = {
		// 'Cookie': document.cookie
	}

	return apiSignin({sesion: idSesion}, 'siimple', headers)
}

export async function apiRefreshToken(federatedInfo, externos, origen){
	
	const API_URL_BASE = await API.endpoint('apiAuthSII')
	const API_URL = new URL('/refresh-token', API_URL_BASE)

	const body = {
		...federatedInfo,
		externos,
		origen
	}
	const init = { method: 'POST', body: JSON.stringify(body) }
	let request = new Request( API_URL, init );
	let response = await fetch(request.clone());
	let resp = await response.json()

	if( response.ok ){
		return resp;
	}else{
		throw resp;
	}
}